export const SET_PAGE = "SET_PAGE";

export const setPage = (payload) => ({payload, type: SET_PAGE});
